export default __webpack_public_path__ + "static/media/generalConfiguration_ic.6da89b82.svg";